import { toast } from 'react-toastify';

/**
 * @function getDefaultConfig
 * @description
 * Devuelve la configuración predeterminada para las notificaciones toast.
 *
 * @returns {Object} Configuración de notificación.
 */
const getDefaultConfig = () => ({
    position: "top-right",
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "dark"
});

/**
 * @function successNotification
 * @description Muestra una notificación de éxito.
 * @param {string} message - Mensaje a mostrar.
 */
export const successNotification = (message) => {
    toast.success(message, getDefaultConfig());
};

/**
 * @function errorNotification
 * @description Muestra una notificación de error.
 * @param {string} message - Mensaje a mostrar.
 */
export const errorNotification = (message) => {
    toast.error(message, getDefaultConfig());
};

/**
 * @function warningNotification
 * @description Muestra una notificación de advertencia.
 * @param {string} message - Mensaje a mostrar.
 */
export const warningNotification = (message) => {
    toast.warning(message, getDefaultConfig());
};

/**
 * @function infoNotification
 * @description Muestra una notificación informativa.
 * @param {string} message - Mensaje a mostrar.
 */
export const infoNotification = (message) => {
    toast.info(message, getDefaultConfig());
};